import React, { useState, useRef } from "react";
import styled from "@emotion/styled";
export const StyledErrorMessage = styled("div")({
  color: "red",
  fontSize: "14px",
});
export const StyledContainter = styled("div")({
  width: "100%",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  // gap: "20px",
});
export const StyledTextarea = styled.textarea`
  width: 100%;
  resize: none;
  padding: 10px;
  border: 1px solid var(--border__color);
  border-radius: 12px;
  height: 100px;
  background: none;
  color: var(--header__color);
  box-sizing: border-box;
  // font-family: "Outfit", sans-serif;
  font-weight: 400;
  rows: ${(props) => props.rows || 3};
  &::placeholder {
    opacity: ${(props) => (props.hasValue ? 0 : 1)};
    transition: opacity 0.3s;
  }
  &:focus {
    outline: none;
  }
`;

export const StyledLabel = styled("div")({
  width:"fit-content",
  marginBottom:"10px"
})

export const StyledAsterisk = styled.span`
  color: red;
  margin-left: ${(props) =>
    props.isFocused || props.hasValue ? "5px" : "5px"};
  position: absolute;
  top: ${(props) => (props.isFocused || props.hasValue ? "-4px" : "-4px")};
`;
function TextArea(props) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleClick = (e) => {
    setIsFocused(true);
    inputRef.current.focus();
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  const {
    placeholder = "",
    name = "",
    value = "",
    onChange = () => "",
    // onBlur = () => "",
    className = "",
    id = "",
    label = "",
    // labelFor = "",
    // labelClassName = "label",
    error = "",
    errorMessage = "",
    errorClassName = "",
    required = false,
    containerClassName = "input-field",
    containerStyle = {},
    autoComplete = "",
    readOnly = false,
    style = {},
    rows = {},
    onKeyDown = () => "",
    disabled = false,
  } = props;
  return (
    <>
      <StyledContainter className={containerClassName} style={containerStyle}>
        <StyledLabel>
          {label}
          {required && (
            <StyledAsterisk isFocused={isFocused} hasValue={value !== ""}>
              *
            </StyledAsterisk>
          )}
        </StyledLabel>
        <StyledTextarea
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={handleClick}
          onBlur={handleBlur}
          className={className}
          id={id}
          required={required}
          autoComplete={autoComplete}
          readOnly={readOnly}
          style={style}
          ref={inputRef}
          isFocused={document.activeElement === inputRef.current && isFocused}
          hasValue={value !== ""}
          showPlaceholder={!placeholder}
          rows={rows}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        {error && (
          <StyledErrorMessage className={errorClassName}>
            {errorMessage}
          </StyledErrorMessage>
        )}
      </StyledContainter>
    </>
  );
}

export default TextArea;
